module.exports = __webpack_public_path__ + "img/card_大师等级@2x.bdced84a.png";